import type { HTMLAttributes } from 'react';
import React from 'react';
import classNames from 'classnames';
import { Icon } from '../../../src/components/atoms/Icon';
import styles from './index.module.scss';

export enum ListItemType {
  Bullet = 'bullet',
  Tick = 'tick',
}

export interface ListItemProps extends HTMLAttributes<HTMLLIElement> {
  children: React.ReactNode;
  listItemType: ListItemType;
  listItemColor?: string;
}

const iconIdMapping = {
  bullet: 'bullet',
  tick: 'check_in_circle',
};

export function ListItem({
  className,
  children,
  listItemType,
  listItemColor = '#5739D8',
  ...props
}: ListItemProps): JSX.Element {
  return (
    <li className={classNames(ListItem.displayName, className, styles.listItem)} {...props}>
      <Icon
        className={listItemType}
        id={iconIdMapping[listItemType]}
        width={24}
        height={24}
        color={listItemColor}
      />
      {children}
    </li>
  );
}
ListItem.displayName = 'ListItem';
